import create from 'zustand';
export var useEditLinkDialogStore = create(function (set) { return ({
    document: undefined,
    isDialogOpen: false,
    openDialog: function (document) { return set({ document: document, isDialogOpen: true }); },
    setDialogOpen: function (isDialogOpen) {
        var newState = { isDialogOpen: isDialogOpen };
        if (!isDialogOpen) {
            newState.document = undefined;
        }
        set(newState);
    },
}); });
//# sourceMappingURL=useEditLinkDialogStore.js.map